import { Spinner } from "react-bootstrap"
import "./FormButtonComponent.scss"

const FormButtonComponent = (props) => {

    const {
        btnName, leftIcon, rightIcon,
        altText, btnAction, isPrimary,
        isDisabled, replaceClassName, showLoader
    } = props

    return (
        <button type="button"
            className={`${replaceClassName ? replaceClassName : 'btn-form-comp'} ${isPrimary ? 'primary-btn' : 'secondary-btn'}`}
            // className="startcourse-btn"
            onClick={btnAction}
            disabled={isDisabled}
        >
            {
                showLoader ?
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        variant="primary"
                    />
                    :
                    <>
                        {leftIcon}
                        <span>{btnName}</span>
                        {rightIcon}
                    </>
            }
        </button>
    )

}

export default FormButtonComponent